import {
    Box,
    Grid,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import ButtonContained from "../../Common/ButtonContained";
import CustomDialog from "../../Common/CustomDialog";
import TextLabel from "../../Common/CommonTextLabel";
import { showLoader } from "../../../Redux/Slices/loaderSlice";
import { useDispatch } from "react-redux";
import {
    createPrivacyPolicyAndTermsAndCondition,
    getPrivacyPolicyAndTermsAndCondition,
    updatePrivacyPolicyAndTermsAndCondition,
} from "../../../Redux/Actions/action";
import ErrorHandler from "../../../Utils/handler";
import { toast } from "react-toastify";
import CommonTextEditor from "../../Common/CommonTextEditor";

function TermsAndConditions() {
    // ---------- Hook -----------
    const dispatch = useDispatch();

    // --------------- State -------------
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({});
    const [privacyPolicyData, setPrivacyPolicyData] = useState({});

    const [error, setError] = useState({});
    const [isEdit, setIsEdit] = useState(false);

    const handleClear = () => {
        setOpen(false);
        setIsEdit(false);
        setData({});
        setError({});
    };

    const validation = () => {
        let isValid = true;
        let error = {};
        if (!data.description) {
            error.description = "Description is required";
            isValid = false;
        }
        setError(error);
        return isValid;
    };

    const _createPrivacyPolicyAndTermsAndCondition = async () => {
        if (validation()) {
            dispatch(showLoader(true));
            try {
                let body = {
                    "type": "Terms-Conditions",
                    description: data?.description,
                }; 
                if (isEdit && data?._id) {
                    body._id = data?._id;
                }
                const fn = isEdit ? updatePrivacyPolicyAndTermsAndCondition : createPrivacyPolicyAndTermsAndCondition
                const result = await dispatch(fn(body));
                const error = ErrorHandler(result);
                if (error) {
                    toast.success(result?.payload?.message);
                    _getPrivacyPolicyAndTermsAndCondition();
                    handleClear();
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            } finally {
                dispatch(showLoader(false));
            }
        }
    };

    const _getPrivacyPolicyAndTermsAndCondition = async () => {
        dispatch(showLoader(true));
        let body = {
            type: "Terms-Conditions",
        };
        try {
            const result = await dispatch(getPrivacyPolicyAndTermsAndCondition(body));
            const error = ErrorHandler(result);
            if (error) {
                setPrivacyPolicyData(result?.payload?.data?.data);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    useEffect(() => {
        _getPrivacyPolicyAndTermsAndCondition();
    }, []);

    return (
        <>
            <Grid container spacing={1} xs={12}>
                <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: 500 }}>
                            Terms & Conditions
                        </Typography>
                        <ButtonContained
                            text={
                                privacyPolicyData?.description
                                    ? "Update Terms & Conditions"
                                    : "Add Terms & Conditions"
                            }
                            onClick={
                                privacyPolicyData?.description
                                    ? () => {
                                        setOpen(true);
                                        setIsEdit(true);
                                        setData({
                                            _id: privacyPolicyData?._id,
                                            description:
                                                privacyPolicyData?.description,
                                        });
                                    }
                                    : () => {
                                        setOpen(true);
                                    }
                            }
                        />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <div dangerouslySetInnerHTML={{ __html: privacyPolicyData?.description }} />
                </Grid>
                {open && (
                    <CustomDialog
                        isOpen={open}
                        handleClose={handleClear}
                        title={isEdit ? "Update Terms & Conditions" : "Add Terms & Conditions"}
                        padding={"10px"}
                        maxWidth={"md"}
                        action={
                            <>
                                <ButtonContained
                                    text={isEdit ? "Update Terms & Conditions" : "Add Terms & Conditions"}
                                    onClick={_createPrivacyPolicyAndTermsAndCondition}
                                    minWidth={"100%"}
                                    marginTop={"10px"}
                                />
                            </>
                        }
                    >
                        <Grid container spacing={2} xs={12} ml={-1}>
                            <Grid item xs={12}>
                                <CommonTextEditor
                                    value={data.description}
                                    onChange={(value) => {
                                        setData({ ...data, description: value });
                                    }}
                                    text={'Description'}
                                    valid={true}
                                />
                                <TextLabel
                                    title={!data?.description ? error?.description : ""}
                                    color="error"
                                />
                            </Grid>
                        </Grid>
                    </CustomDialog>
                )}
            </Grid>
        </>
    );
}

export default TermsAndConditions;
